import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Canonical tracker entry point. Sends visitors and crawlers to the existing
 * exam preparation page so there is a single indexable page per exam.
 */
export const Route = createFileRoute("/tracker/kcet")({
  beforeLoad: () => {
    throw redirect({ to: "/kcet", statusCode: 301 });
  },
});
